import type { PlanejamentoControle } from "@/modules/financeiro-obras";
import type { CentroParaEscopo } from "./adicionar-escopo-macro-dialog";

export function montarCentrosParaEscopo({
  centrosCusto,
}: PlanejamentoControle): CentroParaEscopo[] {
  return centrosCusto
    .map((centro) => ({
      id: centro.id,
      rotulo: `${centro.principal ? "Centro de custo principal" : `Centro de custo ${centro.nome}`} · ${centro.codigo}`,
      principal: centro.principal,
      tipos: centro.tiposObra
        .filter((tipo) => tipo.aceitaEscopo)
        .map((tipo) => ({
          obraTipoObraId: tipo.id,
          tipoObraId: tipo.tipoObra.id,
          codigo: tipo.tipoObra.codigo,
          rotulo: `${tipo.tipoObra.codigo} · ${tipo.tipoObra.nome}`,
          cancelamentoPendente: tipo.solicitacaoPendente === "CANCELAMENTO",
          fonteEscopo: tipo.fonteEscopo,
          escoposIncluidos: tipo.escoposMacro
            .filter((escopo) => escopo.situacao !== "CANCELADO")
            .map((escopo) => escopo.nome),
        })),
    }))
    .sort((a, b) => Number(b.principal) - Number(a.principal));
}
